import { useEffect, useState } from 'react'

export default function TimerBar({ duration, running }) {
  const [progress, setProgress] = useState(100)

  useEffect(() => {
    setProgress(100)
  }, [duration])

  useEffect(() => {
    if (!running) return
    const endTime = Date.now() + duration * 1000
    const interval = setInterval(() => {
      const remainingMs = Math.max(0, endTime - Date.now())
      setProgress((remainingMs / (duration * 1000)) * 100)
      if (remainingMs <= 0) clearInterval(interval)
    }, 16)
    return () => clearInterval(interval)
  }, [running, duration])

  return <div className="timer-bar" style={{ width: `${progress}%` }} />
}